import {
    SUBMIT_UPDATE_REQUEST,
    SUBMIT_UPDATE_SUCCESS,
    SUBMIT_UPDATE_FAILURE,
  } from "../actions/actionTypes";

  import apiClient from '../../utils/apiClient';
  import { useNavigate } from "react-router-dom";

  const RESIDENT_PORTAL_MIDDLEWARE_HOST = process.env.REACT_APP_RESIDENT_PORTAL_MIDDLEWARE_HOST;

  const flattenMessage = (value) => {
    if (Array.isArray(value)) {
      return value.map(flattenMessage).filter(Boolean).join(", ");
    }

    if (value && typeof value === "object") {
      return Object.values(value).map(flattenMessage).filter(Boolean).join(", ");
    }

    if (value === null || value === undefined) {
      return "";
    }

    return String(value);
  };

  export const correctionThunks = (updateData, uniqueId, verificationMethod, signature, regId) => {
    return async (dispatch) => {

      dispatch({ type: SUBMIT_UPDATE_REQUEST });
      try {
        const response = await apiClient.post('/submitCorrectionRequest', {
          updateData,
          uniqueId,
          verificationMethod,
          signature,
          regId,
        });

        if (response.data.response === "OK") {
          dispatch({ type: SUBMIT_UPDATE_SUCCESS, payload: response.data });
        } else {
          throw new Error("Failed to submit update request");
        }
      } catch (error) {
       const message = error?.response?.data?.message?.message || error.message || "update submit failed. Please try again later.";
        dispatch({
          type: SUBMIT_UPDATE_FAILURE,
          payload: message,
        });
      }
    };
  };